"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merCategoryFilter = merCategoryFilter;
exports.merCreateTypeFilter = merCreateTypeFilter;
exports.merchantTypeFilter = merchantTypeFilter;
exports.selfTypeFilter = selfTypeFilter;
var _store = _interopRequireDefault(require("@/store"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

//商户过滤器

/**
 * 商户分类
 */
function merCategoryFilter(status) {
  if (!status) {
    return '';
  }
  var arrayList = _store.default.getters.merchantClassify;
  var array = arrayList.filter(function (item) {
    return status === item.id;
  });
  if (array.length) {
    return array[0].name;
  } else {
    return '';
  }
}

/**
 * 商铺类型
 */
function merchantTypeFilter(status) {
  if (!status) {
    return '';
  }
  var arrayList = _store.default.getters.merchantType;
  var array = arrayList.filter(function (item) {
    return status === item.id;
  });
  if (array.length) {
    return array[0].name;
  } else {
    return '';
  }
}

/**
 * 商户创建类型
 */
function merCreateTypeFilter(status) {
  var statusMap = {
    admin: '管理员创建',
    apply: '商户入驻申请'
  };
  return statusMap[status];
}

/**
 * 商户类别
 */
function selfTypeFilter(status) {
  var statusMap = {
    true: '自营',
    false: '非自营'
  };
  return statusMap[status];
}